import type { ReactNode } from "react";

import { I18nProvider } from "@/shared/i18n";
import { RealtimeProvider } from "@/shared/realtime";
import { TooltipProvider } from "@/shared/ui/tooltip";

import { QueryProvider } from "./QueryProvider";

type AppProvidersProps = {
  children: ReactNode;
};

// Порядок важен: Realtime обновляет кэш Query, поэтому он внутри QueryProvider.
export const AppProviders = ({ children }: AppProvidersProps) => (
  <I18nProvider>
    <QueryProvider>
      <RealtimeProvider>
        <TooltipProvider>{children}</TooltipProvider>
      </RealtimeProvider>
    </QueryProvider>
  </I18nProvider>
);
